import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of, take, withLatestFrom } from 'rxjs';
import {
    LoadSubscriptionsByEmployee,
    LoadSubscriptionsFailure,
    LoadSubscriptionsSuccess,
    UpsertInsuranceNumber,
    UpsertInsuranceNumberFailure,
    UpsertInsuranceNumberSuccess
} from '../actions/employee-subscription.actions';
import { DeleteTransactionSuccess, UpsertTransactionSuccess } from '../actions/employee-transaction.actions';
import { EmployeeProductSubscriptionManagementControllerService } from '@iota/inh-core-v1-management-client';
import { selectedEmployeeId } from '../store';

@Injectable()
export class EmployeeSubscriptionEffects {
    loadSubscriptionsbyEmployee$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadSubscriptionsByEmployee, UpsertInsuranceNumberSuccess),
            mergeMap(({ employeeId }) =>
                this.inhCoreApiService.getByEmployee(employeeId).pipe(
                    take(1),
                    map((subscriptions) => LoadSubscriptionsSuccess({ subscriptions })),
                    catchError((error) => of(LoadSubscriptionsFailure({ error })))
                )
            )
        )
    );

    updateInsuranceNumber$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UpsertInsuranceNumber),
            withLatestFrom(this.store.select(selectedEmployeeId)),
            mergeMap(([{ employeeProductSubscriptionId, insuranceNumber }, employeeId]) =>
                this.inhCoreApiService
                    .upsertEmployeeProductSubscriptionInsuranceNumber(employeeProductSubscriptionId, { insuranceNumber })
                    .pipe(
                        take(1),
                        map(() => UpsertInsuranceNumberSuccess({ employeeId })),
                        catchError((error) => of(UpsertInsuranceNumberFailure({ error })))
                    )
            )
        )
    );

    reloadSubscription$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UpsertTransactionSuccess, DeleteTransactionSuccess),
            withLatestFrom(this.store.select(selectedEmployeeId)),
            map(([, employeeId]) => LoadSubscriptionsByEmployee({ employeeId }))
        )
    );

    constructor(
        private actions$: Actions,
        private store: Store,
        private inhCoreApiService: EmployeeProductSubscriptionManagementControllerService
    ) {}
}
